<template>
  <!--  VISTA LISTAR-->
  <template v-if="view==='listar'">
    <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData"
                     :custom-create-actions="[listFuentesConcretas]"
                     @updateValues="setupUpdateValues"></HeaderComponent>
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
                           @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent :entity="entity" :selected-data="selectedRubro" :table-columns="tableColumns"
                    :collection-data="collectionData" :auth-token="authToken" :list-api="listApi"
                    :custom-update-actions="[listFuentesConcretas]" @updateValues="setupUpdateValues"></TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
                             :optionalParams="queries"
                             @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
  <!--    VISTA CREAR - ACTUALIZAR-->
  <template v-else>
    <CreateUpdateComponent :view="view" :paginate="paginate" :selected-data="selectedRubro"
                           :load-data="loadDataRubro" :entity="entity" :auth-token="authToken"
                           :list-api="listApi" :queries="queries" @updateValues="setupUpdateValues">
      <component :is="childFormComponent" :load-data="loadDataRubro"
                 @updateValues="setupUpdateValues"></component>
    </CreateUpdateComponent>
  </template>
</template>
<script>
import {reactive, ref} from "vue";
import {useAuth} from "@/components/auth/store/composables";
import HeaderComponent from "@/layouts/main/HeaderComponent";
import TableComponent from "@/layouts/main/TableComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import RubrosCrearActualizarComponent
  from "@/components/parametros/components/RubrosCrearActualizarComponent";
import { useLayoutMain} from "@/layouts/main";

export default {
  name: 'RubrosCRUD',
  components: {
    HeaderComponent,
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateComponent,
    RubrosCrearActualizarComponent
  },
  data: function () {
    return {
      Object: Object,
      title: 'Rubros',
      entity: {gender: 'm', value: 'rubro'},
      childFormComponent: 'RubrosCrearActualizarComponent',
      tableColumns: {
        'id': {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: true,
          value: 'ID'
        },
        'rubro': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Rubro'
        },
        'nombre': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Nombre del rubro'
        },
        'estado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Estado'
        },
        'created_at': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Fecha de creación'
        }
      }
    }
  },
  async setup() {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const authToken = ref(authStored.authToken);
    const selectedRubro = ref({
      id: '',
      rubro: '',
      nombre: '',
      estado: ''
    });
    const loadDataRubro = ref({
      rubro: '',
      nombre: '',
    });
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_RUBRO_CREATE,
      list: process.env.VUE_APP_NEST_RUBRO_FINDALL,
      update: process.env.VUE_APP_NEST_RUBRO_UPDATE,
      updateState: process.env.VUE_APP_NEST_RUBRO_UPDATESTATE
    });
    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    } = await useLayoutMain(view, collectionData, authToken, selectedRubro, loadDataRubro, listApi);
    return {
      view,
      collectionData,
      authToken,
      selectedRubro,
      loadDataRubro,
      listApi,
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData,
    };
  }
}
</script>